import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vueSmoothScroll from 'vue2-smooth-scroll'
// Останнім, щоб стилі нового дизайну йшли після стилів компонентів
import './assets/v2.css'
Vue.use(vueSmoothScroll)

Vue.config.productionTip = false
Vue.prototype.SERVER_URL = 'https://api.pizza.black';
// Новий дизайн (демо за посиланням ?v2) — клас ставить скрипт у public/index.html ще до старту Vue
Vue.prototype.$v2 = document.documentElement.classList.contains('bp-v2');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
